module.exports = __webpack_public_path__ + "img/blog.86450ce1.png";